module.exports = __webpack_public_path__ + "static/img/5.0a9ba7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/5.png
// module id = GLnp
// module chunks = 0